export default function gc(cn) {
  return document.getElementsByClassName(cn);
}
